package tta.destinigo.talktoastro.bottom_navigation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.NavigationBarItemColors
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.material3.windowsizeclass.WindowWidthSizeClass
import androidx.compose.material3.windowsizeclass.calculateWindowSizeClass
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import tta.destinigo.talktoastro.bottom_navigation.BottomNavigationComponent.Configuration
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesPage
import tta.destinigo.talktoastro.feature_home.presentation.HomeScreenTab
import tta.destinigo.talktoastro.feature_post.persentation.PostList
import tta.destinigo.talktoastro.feature_profile.MoreScreenTab
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreen
import tta.destinigo.talktoastro.shared.theme.Scale
import tta.destinigo.talktoastro.shared.theme.primaryColor
import tta.destinigo.talktoastro.version_info.getAppVersionInfo


@OptIn(ExperimentalMaterial3WindowSizeClassApi::class)
@Composable
fun BottomNavigationPage(
    component: BottomNavigationComponent
) {
    val stack by component.stack.subscribeAsState()
    val widthClass = calculateWindowSizeClass().widthSizeClass

    val items = listOf(
        BottomTab.HOME,
        BottomTab.COURSES,
        BottomTab.POST,
        BottomTab.FAVORITE,
        BottomTab.MORE
    )

    Scaffold(
        bottomBar = {
            if (widthClass != WindowWidthSizeClass.Expanded) {
                BottomNavigationBar(
                    items = items,
                    selectedIndex = getSelectedIndex(stack.active.configuration),
                    onTabSelected = { index ->
                        component.selectTab(index)
                    }
                )
            }
        }
    ) { padding ->
        Column(modifier = Modifier.padding(padding)) {
            Children(
                stack = stack,
                modifier = Modifier.fillMaxSize()
            ) { child ->
                when (val page = child.instance) {
                    is BottomNavComponent.BottomTabChild.HomeScreenBottomTab -> HomeScreenTab(page.component)
                    is BottomNavComponent.BottomTabChild.ExpertListBottomTab -> CoursesPage(page.component)
                    is BottomNavComponent.BottomTabChild.FavoriteScreenBottomTab -> FavoriteScreen(
                        page.component
                    )

                    is BottomNavComponent.BottomTabChild.PostScreenBottomTab -> PostList(page.component)
                    is BottomNavComponent.BottomTabChild.MoreScreenBottomTab -> MoreScreenTab(
                        page.component,
                        getAppVersionInfo()
                    )
                }
            }
        }
    }
}

fun getSelectedIndex(configuration: Any): Int {
    return when(configuration){
        Configuration.HomeScreenConfig ->  0
        Configuration.CoursesPageConfig ->  1
        Configuration.PostScreenConfig ->  2
        Configuration.FavoriteScreenConfig ->  3
        Configuration.MoreScreeConfig -> 4
        else -> 0
    }
}


@Composable
fun BottomNavigationBar(
    items: List<BottomTab>,
    selectedIndex: Int,
    onTabSelected: (Int) -> Unit
) {
    NavigationBar(
        modifier = Modifier.padding(horizontal = 16.dp),
        containerColor = Color.White,
        tonalElevation = Scale.ELEVATION_MEDIUM
    ) {
        items.forEachIndexed { index, tab ->
            NavigationBarItem(
                icon = {
                    Icon(
                        modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE),
                        imageVector = tab.icon,
                        contentDescription = null
                    )
                },
                label = {
                    Text(
                        text = tab.title,
                        style = MaterialTheme.typography.labelSmall
                    )
                },
                colors = NavigationBarItemColors(
                    selectedIndicatorColor = primaryColor.copy(alpha = 0.18f),
                    selectedIconColor = primaryColor,
                    selectedTextColor = primaryColor,
                    unselectedIconColor = Color.Black,
                    unselectedTextColor = Color.Black,
                    disabledIconColor = Color.Black,
                    disabledTextColor = Color.Black,
                ),
                selected = selectedIndex == index,
                onClick = { onTabSelected(index) }
            )
        }
    }
}
